"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastAction = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _focusMode = require("../../focusMode");
var _ToastActionStyled = require("../styled/ToastActionStyled");
/**
 * @deprecated please use @smartsheet/sds-toast-state-service instead. See
 * https://webappassets.dev.smar.cloud/storybook/design-systems-team/lodestar-core/mainline/sds-toast-ui/storybook/index.html
 */
const ToastAction = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    clientId,
    isDisabled,
    onClick: providedOnClick,
    onDoubleClick: providedOnDoubleClick,
    ...rest
  } = _ref;
  const onClick = (0, _react.useCallback)(e => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnClick) {
      providedOnClick(e);
    }
  }, [isDisabled, providedOnClick]);
  const onDoubleClick = (0, _react.useCallback)(e => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnDoubleClick) {
      providedOnDoubleClick(e);
    }
  }, [isDisabled, providedOnDoubleClick]);
  const {
    focusMode
  } = (0, _focusMode.useFocusMode)();
  return /*#__PURE__*/_react.default.createElement(_ToastActionStyled.ToastActionStyled, (0, _extends2.default)({
    focusMode: focusMode,
    tabIndex: 0,
    "aria-disabled": isDisabled,
    onClick: onClick,
    onDoubleClick: onDoubleClick,
    type: "button",
    "data-client-id": clientId
  }, rest, {
    ref: ref
  }), children);
});
exports.ToastAction = ToastAction;
ToastAction.displayName = "ToastAction";
//# sourceMappingURL=ToastAction.js.map